import React from 'react';

type ControlRoomTitleProps = {
  children: string;
};

/** Mirrors the homepage's two-part title treatment without changing page copy. */
export default function ControlRoomTitle({ children }: ControlRoomTitleProps): React.ReactElement {
  const title = children.trim();
  const lastSpace = title.lastIndexOf(' ');

  if (lastSpace < 0) {
    return <>{title}</>;
  }

  return (
    <>
      <span className="education-control-room-title__lead">{title.slice(0, lastSpace)}</span>{' '}
      <span className="education-control-room-title__accent">{title.slice(lastSpace + 1)}</span>
    </>
  );
}
